// NEW_FILE_JUSTIFIED: Extracted from App.tsx to fix no-giant-component diagnostic
import { useState } from 'react';
import { useAuthActions } from '@convex-dev/auth/react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export function SignUpPage() {
  const { signIn } = useAuthActions();
  const [error, setError] = useState<string | null>(null);
  const [isPending, setIsPending] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    setIsPending(true);

    const formData = new FormData(e.currentTarget);
    const email = formData.get('email') as string;
    const password = formData.get('password') as string;
    const confirmPassword = formData.get('confirmPassword') as string;

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      setIsPending(false);
      return;
    }

    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      setIsPending(false);
      return;
    }

    try {
      await signIn('password', { email, password, flow: 'signUp' });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign up failed');
    } finally {
      setIsPending(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="w-full max-w-md p-8 bg-card rounded-lg border border-border">
        <h1 className="text-3xl font-bold mb-2 text-foreground">Sign Up</h1>
        <p className="text-foreground-muted mb-6">Create your Lead Management account</p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="email" className="text-foreground-muted">
              Email
            </Label>
            <Input
              id="email"
              name="email"
              type="email"
              placeholder="you@example.com"
              required
              disabled={isPending}
              className="mt-1 bg-background-input border-border text-foreground placeholder:text-foreground-placeholder focus:border-border-hover"
            />
          </div>

          <div>
            <Label htmlFor="password" className="text-foreground-muted">
              Password
            </Label>
            <Input
              id="password"
              name="password"
              type="password"
              placeholder="••••••••"
              required
              disabled={isPending}
              className="mt-1 bg-background-input border-border text-foreground placeholder:text-foreground-placeholder focus:border-border-hover"
            />
          </div>

          <div>
            <Label htmlFor="confirmPassword" className="text-foreground-muted">
              Confirm Password
            </Label>
            <Input
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              placeholder="••••••••"
              required
              disabled={isPending}
              className="mt-1 bg-background-input border-border text-foreground placeholder:text-foreground-placeholder focus:border-border-hover"
            />
          </div>

          {error && (
            <div className="p-3 text-sm text-red-400 bg-red-900/20 border border-red-900/50 rounded-md">
              {error}
            </div>
          )}

          <Button
            type="submit"
            className="w-full bg-primary text-primary-foreground hover:bg-primary/90"
            disabled={isPending}
          >
            {isPending ? 'Creating account...' : 'Sign Up'}
          </Button>
        </form>

        <p className="mt-4 text-center text-sm text-foreground-muted">
          Already have an account?{' '}
          <a href="/signin" className="text-link hover:underline">
            Sign in
          </a>
        </p>
      </div>
    </div>
  );
}
